import React from 'react';
import { Box } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PropTypes from 'prop-types';

const SingleCheckmark = ({ size = 16, color = '#4CAF50' }) => (
    <Box
        sx={{
            width: size,
            height: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <DoneIcon
            sx={{
                fontSize: size,
                color: color,
            }}
        />
    </Box>
);

const DoubleCheckmark = ({ size = 16, color = '#4CAF50' }) => (
    <Box
        sx={{
            width: size,
            height: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        <DoneAllIcon
            sx={{
                fontSize: size,
                color: color,
            }}
        />
    </Box>
);

const ReadReceiptIcon = ({ status, size = 16 }) => {
    // Both sent and read use green color
    const color = '#4CAF50'; // Green

    if (status === 'read') {
        return <DoubleCheckmark size={size} color={color} />;
    } else if (status === 'sent') {
        return <SingleCheckmark size={size} color={color} />;
    }

    return null;
};

SingleCheckmark.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

DoubleCheckmark.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

ReadReceiptIcon.propTypes = {
    status: PropTypes.string,
    size: PropTypes.number,
};

export { SingleCheckmark, DoubleCheckmark, ReadReceiptIcon };
export default ReadReceiptIcon;
